export function sortByStringWithEmptyAtEnd<T>(
  items: T[],
  selector: (item: T) => string | null | undefined,
): T[] {
  return [...items].sort((a, b) => {
    const valA = selector(a);
    const valB = selector(b);

    if (!valA && !valB) return 0;
    if (!valA) return 1;
    if (!valB) return -1;

    return valA.localeCompare(valB);
  });
}

export function sortByStringAndOmitEmpty<T>(
  items: T[],
  selector: (item: T) => string | null | undefined,
): T[] {
  return items
    .filter((item) => {
      const val = selector(item);

      // remove null & undefined
      // leaves empty string ''
      return val != null;
    })
    .sort((a, b) => {
      const valA = selector(a) as string;
      const valB = selector(b) as string;

      return valA.localeCompare(valB);
    });
}
